import React, { useEffect, useState, useContext } from 'react';
import { Container, Typography, Stack, Table, TableHead, TableRow, TableCell, TableBody, Button, CircularProgress, TextField, FormControl, InputLabel, Select, MenuItem, IconButton, Box, Tooltip, Alert } from '@mui/material';
import { Visibility, ArrowUpward, ArrowDownward } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../auth/AuthContext';
import ticketApi from '../../api/ticketApi';
import ConfirmDeleteModal from '../../components/ConfirmDeleteModal';
import ProtectedAction from '../../components/ProtectedAction';
import BackButtonDesktop from '../../components/BackButtonDesktop';
import { formatDate } from '../../utils/dateFormatter';

export default function TicketListPageDesktop() {
  const { user } = useContext(AuthContext);
  const [tickets, setTickets] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const [sortField, setSortField] = useState('createdAt');
  const [sortDirection, setSortDirection] = useState('DESC');
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const navigate = useNavigate();
  const pageSize = 10;
  const CATEGORIE = ['ASSISTENZA','BUG','RICHIESTA_INTERNA','AMMINISTRATIVO'];
  const PRIORITA = ['BASSA','MEDIA','ALTA'];
  const STATI = ['APERTO','IN_LAVORAZIONE','CHIUSO'];
  const LIVELLI = ['PRIMO_LIVELLO','SECONDO_LIVELLO'];

  const fetchTickets = (pageNumber = 0) => {
  console.log("fetchTickets");
    setLoading(true);
    const payload = { ...filters };
    if (payload.from) payload.from = new Date(payload.from).toISOString();
    if (payload.to) payload.to = new Date(payload.to).toISOString();
    ticketApi.list(payload, {page: pageNumber, size: pageSize, sort: `${sortField},${sortDirection}`})
      .then(res => {
        setTickets(res.data.content || []);
        setTotalPages(res.data.totalPages || 0);
        setPage(res.data.number || 0);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => fetchTickets(0), [sortField, sortDirection]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const applyFilters = () => fetchTickets(0);
  const clearFilters = () => { setFilters({}); fetchTickets(0); };

  const handleSort = (field) => {
    if (sortField === field) setSortDirection(sortDirection === 'ASC' ? 'DESC' : 'ASC');
    else { setSortField(field); setSortDirection('ASC'); }
    console.log("field",field);
    console.log("sortField",sortField);
    console.log("sortDirection",sortDirection);
  };

  const renderSortIcon = (field) => {
    if (sortField !== field) return null;
    return sortDirection === 'ASC' ? <ArrowUpward fontSize="small" /> : <ArrowDownward fontSize="small" />;
  };

  const openDeleteDialog = (id) => { setSelectedId(id); setOpenDeleteModal(true); };
  const closeDeleteDialog = () => { setSelectedId(null); setOpenDeleteModal(false); };
  const confirmDelete = async () => { try { await ticketApi.delete(selectedId); fetchTickets(page); } catch (err) { console.error(err); } closeDeleteDialog(); };

  return (
    <Container>
      {loading && <Box sx={{ position: 'fixed', inset: 0, bgcolor: 'rgba(255,255,255,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300 }}><CircularProgress size={48}/></Box>}

      <BackButtonDesktop />
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h4">Tickets</Typography>
      </Stack>

      {/* Filtri */}
      <Stack direction="row" spacing={2} sx={{ mb: 2, flexWrap: 'wrap' }}>
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel>Stato</InputLabel>
          <Select name="stato" value={filters.stato || ''} onChange={handleFilterChange} label="Stato">
            <MenuItem value=""><em>None</em></MenuItem>
            {STATI.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel>Priorità</InputLabel>
          <Select name="priorita" value={filters.priorita || ''} onChange={handleFilterChange} label="Priorita">
            <MenuItem value=""><em>None</em></MenuItem>
            {PRIORITA.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
          </Select>
        </FormControl>
         <FormControl size="small" sx={{ minWidth: 140 }}>
           <InputLabel>Categoria</InputLabel>
           <Select name="categoria" value={filters.categoria || ''} onChange={handleFilterChange} label="Categoria">
             <MenuItem value=""><em>None</em></MenuItem>
             {CATEGORIE.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
           </Select>
         </FormControl>
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel>Livello</InputLabel>
          <Select name="livello" value={filters.livello || ''} onChange={handleFilterChange} label="Livello">
            <MenuItem value=""><em>None</em></MenuItem>
            {LIVELLI.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
          </Select>
        </FormControl>
         <TextField
           label="Creato da"
           name="from"
           type="date"
           InputLabelProps={{ shrink: true }}
           value={filters.from || ''}
           onChange={handleFilterChange}
           size="small"
         />
         <TextField
           label="A"
           name="to"
           type="date"
           InputLabelProps={{ shrink: true }}
           value={filters.to || ''}
           onChange={handleFilterChange}
           size="small"
         />
        <Button variant="contained" onClick={applyFilters}>Cerca</Button>
        <Button variant="outlined" onClick={clearFilters}>Resetta Filtri</Button>
      </Stack>
  <Stack direction="row" spacing={1}>
    {(user.role=="CONTRIBUENTE" || user.role=="STUDIO") && (
    <ProtectedAction user={user} contractState={user.statoContratto}>
        <Button variant="contained" color="primary" onClick={() => navigate(`/tickets/create`)}>
          Inserisci Ticket
        </Button></ProtectedAction>
     )}
  </Stack>
        {/* Paginazione */}
        <Stack direction="row" spacing={1} sx={{ mt: 2, flexWrap: 'wrap' }}>
          {Array.from({ length: totalPages }, (_, i) => (
            <Button key={i} variant={i === page ? 'contained' : 'outlined'} onClick={() => fetchTickets(i)}>{i + 1}</Button>
          ))}
        </Stack>
      <Table>
        <TableHead>
          <TableRow>
              <TableCell onClick={() => handleSort('id')} style={{ cursor: 'pointer' }}>ID {renderSortIcon('id')}</TableCell>
              <TableCell>Utente</TableCell>
             <TableCell onClick={() => handleSort('stato')} style={{ cursor: 'pointer' }}>Stato {renderSortIcon('stato')}</TableCell>
              <TableCell onClick={() => handleSort('priorita')} style={{ cursor: 'pointer' }}>Priorità {renderSortIcon('priorita')}</TableCell>
              <TableCell onClick={() => handleSort('livello')} style={{ cursor: 'pointer' }}>Livello {renderSortIcon('livello')}</TableCell>
              <TableCell onClick={() => handleSort('oggetto')} style={{ cursor: 'pointer' }}>Oggetto {renderSortIcon('oggetto')}</TableCell>
              <TableCell onClick={() => handleSort('createdAt')} style={{ cursor: 'pointer' }}>Data Creazione {renderSortIcon('createdAt')}</TableCell>
            <TableCell>Azioni</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tickets.map(t => (
            <TableRow key={t.id}>
              <TableCell>{t.id}</TableCell>
              <TableCell>{t.cognomeNomeUtente}</TableCell>
              <TableCell>{t.stato}</TableCell>
              <TableCell>{t.priorita}</TableCell>
              <TableCell>{t.livello}</TableCell>
              <TableCell>{t.oggetto}</TableCell>
              <TableCell>{formatDate(t.createdAt)}</TableCell>
              <TableCell>
                <Stack direction="row" spacing={1}>
                  <Tooltip title="Visualizza">
                    <IconButton size="small" color="primary" onClick={() => navigate(`/tickets/${t.id}`)}><Visibility /></IconButton>
                  </Tooltip>
                  <ProtectedAction user={user} roles={['ADMIN']}>
                    <Button size="small" onClick={() => navigate(`/tickets/${t.id}`)}>Aggiorna Stato</Button>
                    <Button size="small" onClick={() => navigate(`/tickets/${t.id}`)}>Aggiorna Livello</Button>
                  </ProtectedAction>
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* Paginazione */}
      <Stack direction="row" spacing={1} sx={{ mt: 2, flexWrap: 'wrap' }}>
        {Array.from({ length: totalPages }, (_, i) => (
          <Button key={i} variant={i === page ? 'contained' : 'outlined'} onClick={() => fetchTickets(i)}>{i + 1}</Button>
        ))}
      </Stack>

      <ConfirmDeleteModal
        open={openDeleteModal}
        onCancel={closeDeleteDialog}
        onConfirm={confirmDelete}
        message="Sei sicuro di voler eliminare questo ticket?"
      />
    </Container>
  );
}